import React from 'react';

const ResultURL = ({ url }) => {
    return (
        <div className="sui-result__url">
            {url}
        </div>
    );
};

export default ResultURL;
